import styled, {css, DefaultTheme} from 'styled-components'

export type EmptySearchVariant = 'primary' | 'secondary'

export type StyledEmptySearchProps = {
    $variant: EmptySearchVariant
}

const makeEmptySearchVariantStyle = (theme: DefaultTheme) =>
    ({
        primary: css`
            background: ${theme.palette.neutral['white']};
            border: 1px solid ${theme.palette.neutral['200']};
            color: ${theme.palette.neutral['900']};
        `,
        secondary: css`
            background: ${theme.palette.neutral['50']};
            color: ${theme.palette.neutral['900']};
        `
    }) as const satisfies Record<EmptySearchVariant, ReturnType<typeof css>>

export const StyledEmptyState = styled('div')<StyledEmptySearchProps>(
    ({theme, $variant}) => css`
        width: 100%;
        padding: ${theme.spacing * 10}px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: ${theme.spacing * 3}px;
        text-align: center;
        height: max-content;

        ${makeEmptySearchVariantStyle(theme)[$variant]};

        h3 {
            ${theme.typography.textLg};
        }
        h4 {
            ${theme.typography.textSm};
            color: ${theme.palette.neutral['500']};
        }
    `
)
